<ng-container *ngIf="initialized">
        <div (click)="handleClick()" class="pointer" *ngIf="leadDto">
            <inline-template-component
                    [objectType]="'lm.LmLead'"
                    [name]="leadDto.calculatedName"
                    [uiDescription]="leadDto.clientEmail"
                    [showEndTime]="false"
                    [status]="LmEntityStatusEnum[leadDto.entityStatus]" >
            </inline-template-component>

        </div>
</ng-container>
